var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOuvrirLaPorte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 93.664 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.5)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 884",
    d: "M93.664 63.5h-10.25V7.75a6.257 6.257 0 0 0-6.25-6.25H50.039a6.257 6.257 0 0 0-6.25 6.25V63.5H-.002v-3h40.791V7.75a9.248 9.248 0 0 1 9.25-9.25h27.125a9.26 9.26 0 0 1 9.25 9.25V60.5h7.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 886",
    d: "M41.39 61.839H9.364V7.319a3.305 3.305 0 0 1 3.205-3.392h25.62a3.305 3.305 0 0 1 3.2 3.392Zm-30.026-2H39.39V7.319a1.309 1.309 0 0 0-1.2-1.392H12.569a1.309 1.309 0 0 0-1.2 1.392Z"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 2446",
    width: 7.986,
    height: 3.194,
    rx: 1,
    transform: "translate(14.285 34.592)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOuvrirLaPorte);
export default __webpack_public_path__ + "static/media/ouvrir-la-porte.124f2c08c325cfdf04a3b6681a799ad4.svg";
export { ForwardRef as ReactComponent };